import { ButtonTypes } from '@cox/core-ui8/dist/Button'

import { Placeholder } from '../../shared/ReactBootstrap'
import { TeaserType, variantClass, Variation } from '../types'

interface ReactStandardTeaserSkeletonProps {
  variation: Variation
  cardType: TeaserType
}
const ReactStandardTeaserSkeleton = ({ variation, cardType }: ReactStandardTeaserSkeletonProps) => {
  return (
    <div data-testid={`react-standard-teaser-container`} className={`react-standard-teaser-container row`}>
      {variation === Variation.withimage && (
        <div className='col-md-12 col-lg-5 squareImage'>
          <div className='squareImage squareBgImage skeleton-img-placeholder' />
        </div>
      )}
      <div
        className={`react-standard-teaser-card ${cardType} ${variantClass[variation]} col-md-12 ${
          variation === Variation.withimage ? 'col-lg-7' : 'col-lg-12'
        }`}
      >
        <Placeholder as={'span'} style={{ height: '20px', width: '100px', backgroundColor: 'grey', borderRadius: '20px' }} />
        <Placeholder className='eyebrow' xs={7} />
        <Placeholder className='heading' xs={7} />
        <Placeholder className='description' xs={7} />
        <Placeholder.Button xs={6} variant={ButtonTypes.PRIMARY} style={{ marginTop: '5px' }} />
      </div>
    </div>
  )
}

export default ReactStandardTeaserSkeleton
